import {
    IRegisterUserForm,
    IUserResponse,
  } from 'services/clientUserManagment/types';
  
  export const userQueryToForm = (
    userQuery: IUserResponse
  ): IRegisterUserForm => {
    const { id, permissions, ...user } = userQuery;
  
    return {
    ...user,
    isTwoFactorEnabled: false,
  }
  };
  